/* ---------------------------------------------------------------------------
   Grabado láser RTIC — motor de preview
   Elevum · septiembre 2026

   Toda la composición ocurre en el navegador: no hay servidor, no hay IA y no
   hay llamada de red. El archivo que sube el cliente nunca sale de su equipo
   hasta que Shopify lo manda junto con el pedido.

   Arquitectura (la misma que usa RTIC US, verificada en su endpoint
   /custom/config/<itemId>):
     foto del producto  +  textura de acero recortada por el arte  =  grabado
   No hay 3D en ningún momento; el config de RTIC trae perspective: 0.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  // Llegó desde el letrero de la tarjeta en la colección. Se lee aquí, al
  // cargar, porque Empire reescribe la URL con ?variant= y borra el #grabado;
  // por eso la tarjeta también deja la marca en sessionStorage.
  var desdeTarjeta = location.hash === '#grabado';
  try {
    if (sessionStorage.getItem('grabado-ir') === '1') desdeTarjeta = true;
    sessionStorage.removeItem('grabado-ir');
  } catch (e) {}

  var root = document.getElementById('grabado-root');
  if (!root) return;

  var CFG;
  try { CFG = JSON.parse(root.getAttribute('data-config')); }
  catch (e) { return; }

  var STAGE = CFG.stage || 2000;
  var BODY  = CFG.body;                 // caja del cuerpo en px sobre la foto
  var MM    = CFG.mm;                   // medidas físicas del producto

  // Área grabable, derivada de las medidas físicas: así un termo nuevo se da
  // de alta con sus milímetros y no hay que recalcular píxeles a mano.
  var ZONE = {
    w: BODY.w * (MM.areaW / MM.cuerpoW),
    h: BODY.h * (MM.areaH / MM.cuerpoH),
    x: BODY.x + (BODY.w - BODY.w * (MM.areaW / MM.cuerpoW)) / 2,
    y: BODY.y + BODY.h * (MM.offsetTop / MM.cuerpoH)
  };
  var MM_PER_PX = MM.areaW / ZONE.w;

  var cv    = root.querySelector('.grabado-canvas');
  var hint  = root.querySelector('.grabado-hint');
  var flag  = root.querySelector('.grabado-flag');
  var busy  = root.querySelector('.grabado-busy');

  var photos = {}, steel = null, pending = 0, booted = false;

  /* Acero cepillado generado por código, para no depender de subir una imagen.
     Lo que lo hace leer como láser y no como pintura plateada:
       - rayado HORIZONTAL fino: cada renglón lleva su propio tono y encima un
         ruido estirado a lo largo, como las marcas del cepillo;
       - gris MEDIO y mate, sin aclarar: el acero grabado no brilla;
       - un sombreado de cilindro muy leve, no bandas de reflejo marcadas.
     Se genera a 1:1 con el cuerpo en pantalla para que el rayado se vea. */
  function makeSteel(w, h) {
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var g = c.getContext('2d');
    var img = g.createImageData(w, h), d = img.data;
    var ruido = new Float32Array(w), acc = new Float32Array(w + 1);
    var R = 26;                                   // largo del trazo del cepillo

    for (var y = 0; y < h; y++) {
      var renglon = (Math.random() - 0.5) * 16;   // cada renglón, su propio tono
      for (var x = 0; x < w; x++) ruido[x] = Math.random() * 2 - 1;
      acc[0] = 0;
      for (x = 0; x < w; x++) acc[x + 1] = acc[x] + ruido[x];
      for (x = 0; x < w; x++) {
        var a = x < R ? 0 : x - R, b = x + R + 1 > w ? w : x + R + 1;
        var estirado = (acc[b] - acc[a]) / (b - a) * 110;
        var t = x / w;
        var cilindro = 9 * Math.cos((t - 0.38) * Math.PI * 1.1) - 6;
        var v = 146 + renglon + estirado + cilindro;
        var i = (y * w + x) * 4;
        d[i] = v - 2; d[i + 1] = v; d[i + 2] = v + 3; d[i + 3] = 255;
      }
    }
    g.putImageData(img, 0, 0);
    return c;
  }

  /* Tipografías. Son las mismas que RTIC US ofrece en su personalizador
     (endpoint /custom/assets), quedándonos con las que existen en Google
     Fonts. Las otras siete de su catálogo — Freshman, Julisa, Amador,
     Antonietta, Bison, Varsity Team — son comerciales y necesitan licencia
     propia; no se toman de su sitio. */
  var FONTS = [
    { id: 'poppins',  nom: 'Poppins',       css: '"Poppins", Helvetica, Arial, sans-serif', peso: '700', grupo: 'Bloque' },
    { id: 'league',   nom: 'League Gothic', css: '"League Gothic", Impact, sans-serif',     peso: '400', grupo: 'Bloque' },
    { id: 'fugaz',    nom: 'Fugaz One',     css: '"Fugaz One", Impact, sans-serif',         peso: '400', grupo: 'Bloque' },
    { id: 'stencil',  nom: 'Saira Stencil', css: '"Saira Stencil One", Impact, sans-serif', peso: '400', grupo: 'Bloque' },
    { id: 'lora',     nom: 'Lora',          css: '"Lora", Georgia, serif',                  peso: '700', grupo: 'Serif' },
    { id: 'zen',      nom: 'Zen Antique',   css: '"Zen Antique", Georgia, serif',           peso: '400', grupo: 'Serif' },
    { id: 'pacifico', nom: 'Pacifico',      css: '"Pacifico", cursive',                     peso: '400', grupo: 'Manuscrita' },
    { id: 'praise',   nom: 'Praise',        css: '"Praise", cursive',                       peso: '400', grupo: 'Manuscrita' },
    { id: 'gwendolyn',nom: 'Gwendolyn',     css: '"Gwendolyn", cursive',                    peso: '700', grupo: 'Manuscrita' },
    { id: 'monte',    nom: 'MonteCarlo',    css: '"MonteCarlo", cursive',                   peso: '400', grupo: 'Manuscrita' }
  ];
  function fontById(id) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].id === id) return FONTS[i];
    return FONTS[0];
  }

  /* Ejemplo: mientras el cliente no sube nada, el termo se muestra ya grabado
     con "TU LOGO". Es la forma más rápida de entender qué se está comprando.
     Nunca cuenta como arte real: no cobra, no viaja al carrito. */
  function artEjemplo() {
    var c = document.createElement('canvas');
    c.width = 1000; c.height = 300;
    var g = c.getContext('2d');
    g.fillStyle = '#000'; g.textAlign = 'center'; g.textBaseline = 'middle';
    g.font = '900 210px "Arial Black", Impact, "Helvetica Neue", sans-serif';
    var w = g.measureText('TU LOGO').width;
    if (w > 960) g.font = '900 ' + Math.floor(210 * 960 / w) + 'px "Arial Black", Impact, sans-serif';
    g.fillText('TU LOGO', 500, 158);
    return c;
  }
  var EJEMPLO = artEjemplo();
  function hayArte() { return !!(faces.frente.art || faces.reverso.art); }

  function newFace() {
    return { src: null, art: null, artMM: null, file: null,
             text: '', font: 'poppins', mayus: true, textSize: 100,
             size: 100, pos: 50, thr: 50, bg: 'claro', fname: '' };
  }
  var faces  = { frente: newFace(), reverso: newFace() };
  var active = 'frente';
  function F() { return faces[active]; }

  /* ---------------------------------------------------------------- carga */
  function assetReady() { if (--pending === 0) boot(); }

  ['frente', 'reverso'].forEach(function (k) {
    if (!CFG.fotos[k]) return;
    pending++;
    photos[k] = new Image();
    photos[k].crossOrigin = 'anonymous';
    photos[k].onload = photos[k].onerror = assetReady;
    photos[k].src = CFG.fotos[k];
  });
  if (CFG.textura) {
    pending++;
    steel = new Image();
    steel.crossOrigin = 'anonymous';
    steel.onload = steel.onerror = assetReady;
    steel.src = CFG.textura;
  } else {
    steel = makeSteel(560, 1400);
  }

  /* -------------------------------------------------------- procesamiento */
  function processLogo() {
    var f = F();
    if (!f.src) { f.art = null; f.artMM = null; return; }

    var sw = f.src.width || f.src.naturalWidth;
    var sh = f.src.height || f.src.naturalHeight;
    // Margen de sobra sobre los ~500 px que mide el área en pantalla: el
    // downscale final es lo que da el filo del borde.
    var scale = Math.min(1, 1600 / Math.max(sw, sh));
    var w = Math.max(1, Math.round(sw * scale));
    var h = Math.max(1, Math.round(sh * scale));

    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    g.drawImage(f.src, 0, 0, w, h);

    var data;
    try { data = g.getImageData(0, 0, w, h); }
    catch (e) { f.art = null; say('El navegador bloqueó la lectura del archivo. Expórtalo como PNG.'); return; }
    var px = data.data;

    var cut = f.thr * 2.55, darkBg = f.bg === 'oscuro';
    // Rampa alrededor del umbral. Un corte duro destruye el antialiasing del
    // archivo y deja el borde dentado al reducirlo.
    var SOFT = 22;
    var minX = w, minY = h, maxX = -1, maxY = -1, mid = 0, kept = 0;

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4, a = px[i + 3];
        var lum = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2];
        if (lum > 60 && lum < 200 && a > 40) mid++;

        var d = darkBg ? (lum - cut) : (cut - lum);
        var t = (d + SOFT) / (SOFT * 2);
        t = t < 0 ? 0 : t > 1 ? 1 : t;

        px[i] = 0; px[i + 1] = 0; px[i + 2] = 0; px[i + 3] = Math.round(t * a);

        if (t > 0.5 && a > 40) {
          kept++;
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
    }

    if (maxX < 0) {
      f.art = null; f.artMM = null;
      say('Con esta sensibilidad no queda nada del logo. Mueve el control, o cambia el fondo a Oscuro si el logo es blanco.');
      return;
    }

    g.putImageData(data, 0, 0);
    var bw = maxX - minX + 1, bh = maxY - minY + 1;
    var trimmed = document.createElement('canvas');
    trimmed.width = bw; trimmed.height = bh;
    var tg = trimmed.getContext('2d');
    tg.imageSmoothingEnabled = true; tg.imageSmoothingQuality = 'high';
    tg.drawImage(c, minX, minY, bw, bh, 0, 0, bw, bh);
    f.art = trimmed;

    if (mid / (w * h) > 0.22)
      say('El logo trae muchos medios tonos (degradados o sombras). El grabado no los reproduce: revisa que la silueta siga siendo reconocible.');
    else if (kept / (bw * bh) < 0.06)
      say('El trazo quedó muy delgado para grabarse limpio. Súbele a la sensibilidad o pide el logo en vectores.');
    else say(null);
  }

  function say(msg) {
    if (!flag) return;
    if (msg) { flag.textContent = msg; flag.hidden = false; }
    else flag.hidden = true;
  }

  /* ---------------------------------------------------------------- render */
  function engraveLayer(w, h, paint) {
    var off = document.createElement('canvas');
    off.width  = Math.max(1, Math.round(w));
    off.height = Math.max(1, Math.round(h));
    var o = off.getContext('2d');
    o.imageSmoothingEnabled = true; o.imageSmoothingQuality = 'high';
    // La máscara se arma en un canvas aparte, en composición normal.
    // Dentro de 'destination-in' cada dibujo INTERSECTA al anterior en vez de
    // sumarse: el texto recortaba el logo contra sí mismo y, como no se tocan,
    // no quedaba nada. Con una sola operación al final eso no puede pasar.
    var mk = document.createElement('canvas');
    mk.width = off.width; mk.height = off.height;
    var m = mk.getContext('2d');
    m.imageSmoothingEnabled = true; m.imageSmoothingQuality = 'high';
    paint(m, mk.width, mk.height);

    // La textura se escala al ancho COMPLETO del cuerpo para que sus bandas de
    // luz coincidan con la curvatura del cilindro; luego se recorta.
    // Sin filtro de brillo: el acero grabado es gris medio y mate. Se recorta
    // la textura a la proporción de la capa para no aplastar el rayado.
    var sh = Math.min(steel.height, steel.width * off.height / BODY.w);
    o.drawImage(steel, 0, 0, steel.width, sh, -(ZONE.x - BODY.x), 0, BODY.w, off.height);
    o.globalCompositeOperation = 'destination-in';
    o.drawImage(mk, 0, 0);
    return off;
  }

  function layout(art, boxW, boxH, text, textScale) {
    // El texto se mide contra el ANCHO del área, no contra el alto del logo.
    // Midiéndolo contra el alto, un logo apaisado dejaba una franja mínima y
    // el nombre salía diminuto; y como el bloque tomaba el ancho del logo, un
    // logo angosto aplastaba el texto hasta perderlo.
    var base   = Math.min(boxH * 0.15, boxW * 0.105);
    var textH  = text ? base * ((textScale || 100) / 100) : 0;
    var gap    = text ? textH * 0.40 : 0;
    var availH = Math.max(1, boxH - textH - gap);
    var k  = Math.min(boxW / art.width, availH / art.height);
    var lw = art.width * k, lh = art.height * k;
    return {
      logoW: lw, logoH: lh, textH: textH, gap: gap,
      // Con texto el bloque ocupa todo el ancho disponible y el logo se centra
      // dentro; sin texto, el bloque es el logo y ya.
      w: text ? boxW : lw,
      total: lh + gap + textH
    };
  }

  function render(c, faceKey, textOverride, showZone) {
    var f = faces[faceKey];
    var photo = photos[faceKey] || photos.frente;
    var g = c.getContext('2d'), s = c.width / STAGE;

    g.clearRect(0, 0, c.width, c.height);
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    g.save();
    g.scale(s, s);
    if (photo && photo.complete && photo.naturalWidth) g.drawImage(photo, 0, 0, STAGE, STAGE);

    var text = (textOverride == null ? f.text : textOverride).trim();

    var art = f.art, ejemplo = false;
    if (!art && !hayArte() && faceKey === 'frente') { art = EJEMPLO; ejemplo = true; text = ''; }

    if (art) {
      var k = ejemplo ? 0.92 : f.size / 100;
      var L  = layout(art, ZONE.w * k, ZONE.h * k, text, f.textSize);
      var lw = Math.max(1, L.w), lh = Math.max(1, L.total);
      var x  = ZONE.x + (ZONE.w - lw) / 2;
      var y  = ZONE.y + (ZONE.h - lh) * ((ejemplo ? 50 : f.pos) / 100);

      var layer = engraveLayer(lw, lh, function (o, W) {
        o.drawImage(art, (W - L.logoW) / 2, 0, L.logoW, L.logoH);
        if (text) {
          var ft = fontById(f.font);
          // Las manuscritas pierden legibilidad en versalitas; van tal cual.
          var up = (f.mayus && ft.grupo !== 'Manuscrita') ? text.toUpperCase() : text;
          o.fillStyle = '#000';
          o.textAlign = 'center'; o.textBaseline = 'middle';
          var px = L.textH * (ft.grupo === 'Manuscrita' ? 1.15 : 0.88);
          for (var i = 0; i < 90 && px > 4; i++) {
            o.font = ft.peso + ' ' + px + 'px ' + ft.css;
            if (o.measureText(up).width <= W * 0.96) break;
            px -= 1;
          }
          o.fillText(up, W / 2, L.logoH + L.gap + L.textH / 2);
        }
      });

      // Profundidad con sombra propia, no con una copia desplazada: duplicar
      // la capa emborrona el borde en logos con texto fino.
      g.save();
      // Sin sombra: el láser quita la pintura al ras, no deja relieve. La
      // sombra lo hacía ver como calcomanía pegada encima.
      g.drawImage(layer, x, y, lw, lh);
      g.restore();

      // Se reporta el logo, no el bloque: es la medida que le importa al taller.
      if (textOverride == null) f.artMM = ejemplo ? null : { w: L.logoW * MM_PER_PX, h: L.logoH * MM_PER_PX };
    } else if (textOverride == null) {
      f.artMM = null;
    }

    if (showZone) {
      g.strokeStyle = 'rgba(59,78,158,.85)';
      g.setLineDash([7, 6]); g.lineWidth = 3;
      g.strokeRect(ZONE.x, ZONE.y, ZONE.w, ZONE.h);
      g.setLineDash([]);
    }
    g.restore();
  }

  function refresh() {
    var zoneOn = root.querySelector('.grabado-zone');
    render(cv, active, null, zoneOn ? zoneOn.checked : false);

    var f = F();
    if (hint) {
      hint.textContent = f.artMM
        ? 'Tu logo: ' + f.artMM.w.toFixed(0) + ' × ' + f.artMM.h.toFixed(0) +
          ' mm · área ' + MM.areaW + ' × ' + MM.areaH + ' mm'
        : 'Ejemplo · sube tu logo y aquí lo ves en tu termo';
    }

    root.querySelectorAll('[data-face]').forEach(function (b) {
      var dot = b.querySelector('.grabado-dot');
      if (dot) dot.classList.toggle('on', !!faces[b.getAttribute('data-face')].art);
    });

    pintarChips();
    pintarPasos();
    pintarResumen();
    pintarVolumen();
    markCTA();
    syncCart();
  }

  /* Las dos miniaturas del panel: el archivo tal cual entró y cómo va a
     quedar grabado. Es lo que hace entendible el control de detalle — se ve
     el efecto en lugar de leer un número. */
  function encajar(ctx, img, W, H, pad) {
    var iw = img.width || img.naturalWidth, ih = img.height || img.naturalHeight;
    if (!iw || !ih) return;
    var k = Math.min((W - pad * 2) / iw, (H - pad * 2) / ih);
    var w = iw * k, h = ih * k;
    ctx.drawImage(img, (W - w) / 2, (H - h) / 2, w, h);
  }

  function colorDelTermo() {
    // Se muestrea la propia foto dentro del área grabable, así el fondo de la
    // miniatura es el color real del producto y no un gris inventado.
    var ph = photos[active] || photos.frente;
    if (!ph || !ph.complete || !ph.naturalWidth) return '#33415c';
    try {
      var t = document.createElement('canvas');
      t.width = 1; t.height = 1;
      var g = t.getContext('2d');
      g.drawImage(ph, ZONE.x + ZONE.w * 0.5, ZONE.y + ZONE.h * 0.5, 1, 1, 0, 0, 1, 1);
      var d = g.getImageData(0, 0, 1, 1).data;
      return 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
    } catch (e) { return '#33415c'; }
  }

  function pintarChips() {
    var f = F();
    var a = root.querySelector('.grabado-chip-src');
    var b = root.querySelector('.grabado-chip-out');
    if (!a || !b) return;

    var ga = a.getContext('2d');
    ga.clearRect(0, 0, a.width, a.height);
    ga.fillStyle = '#fff'; ga.fillRect(0, 0, a.width, a.height);
    ga.imageSmoothingQuality = 'high';
    if (f.src) encajar(ga, f.src, a.width, a.height, 8);

    var gb = b.getContext('2d');
    gb.clearRect(0, 0, b.width, b.height);
    gb.fillStyle = colorDelTermo(); gb.fillRect(0, 0, b.width, b.height);
    gb.imageSmoothingQuality = 'high';
    if (f.art) {
      var pad = 10;
      var k = Math.min((b.width - pad * 2) / f.art.width, (b.height - pad * 2) / f.art.height);
      var w = Math.max(1, f.art.width * k), h = Math.max(1, f.art.height * k);
      var capa = engraveLayer(w, h, function (o, W, H) { o.drawImage(f.art, 0, 0, W, H); });
      gb.drawImage(capa, (b.width - w) / 2, (b.height - h) / 2, w, h);
    }
  }

  function reprocess() { processLogo(); refresh(); }

  /* ------------------------------------------------ enganche con el carrito
     Los datos viajan como line item properties. Las que empiezan con "_" no se
     le muestran al cliente, pero sí aparecen en el pedido dentro del admin,
     que es donde el taller las necesita.                                     */
  var cartBox = null;

  function cartTarget() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  /* El grabado es un producto aparte del catálogo ("Grabado Laser Termos").
     Cuando el cliente deja puesto su logo, esa línea tiene que entrar al
     carrito sola: se agrega por AJAX justo antes de que el formulario del
     tema mande el termo, con una unidad por cada cara grabada. */
  var yaCobrado = false;

  /* El cobro viaja en el propio config del producto (metafield), no en un
     ajuste de la sección: Shopify tarda en reconocer ajustes recién añadidos
     al schema y los renderiza vacíos. Así cada producto lleva además su
     propio precio de grabado. El ajuste queda de respaldo. */
  function cobro() { return (CFG && CFG.cobro) || {}; }

  /* El grabado no cuesta igual por volumen. `escalones` permite una entrada
     por rango: { desde, variante, texto }. Si la cantidad cae en un escalón
     que todavía no tiene variante dada de alta, NO se cobra nada y se avisa
     que va por cotización: es preferible cotizar a cobrar de menos. */
  function escalonPara(piezas) {
    var c = cobro();
    var lista = c.escalones;
    if (!lista || !lista.length) {
      return { variante: c.variante, texto: c.texto, desde: 1 };
    }
    var elegido = null;
    for (var i = 0; i < lista.length; i++) {
      var e = lista[i];
      if (piezas >= (e.desde || 1) && (!elegido || (e.desde || 1) >= (elegido.desde || 1))) elegido = e;
    }
    return elegido || lista[0];
  }

  function variantGrabado(piezas) {
    var e = escalonPara(piezas || 1);
    var v = String((e && e.variante) || root.getAttribute('data-variant-grabado') || '').trim();
    return /^[0-9]+$/.test(v) ? v : null;
  }

  function cantidadDelForm(form) {
    var q = form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  function engancharCobro() {
    var form = cartTarget();
    if (!form || form.dataset.grabadoCobro === '1') return;
    form.dataset.grabadoCobro = '1';

    var q = form.querySelector('[name="quantity"]');
    if (q) {
      q.addEventListener('change', refresh);
      q.addEventListener('input', refresh);
    }

    /* Se escucha en fase de CAPTURA y se corta la propagación.
       Empire tiene su propio envío AJAX para este formulario: sin cortarlo,
       el termo entraba dos veces (el suyo y el nuestro) y la promo de 2do
       termo se colaba sola. Con captura, este handler corre primero y el del
       tema ya no se ejecuta. */
    var destino = '/cart';

    function interceptar(e) {
      var caras = (faces.frente.art ? 1 : 0) + (faces.reverso.art ? 1 : 0);
      if (!caras || yaCobrado) return;          // sin logo: compra normal

      var piezas = cantidadDelForm(form);
      var vid = variantGrabado(piezas);

      e.preventDefault();
      e.stopImmediatePropagation();

      if (!vid) {
        // Volumen sin tarifa: no se cobra de más, se manda el diseño.
        var liga = ligaWhatsApp(piezas);
        if (liga) {
          say('Para ' + piezas + ' piezas el grabado se cotiza aparte. Te abrimos WhatsApp con tu diseño.');
          window.open(liga, '_blank', 'noopener');
        } else {
          say('Para ' + piezas + ' piezas el grabado se cotiza aparte. Te contactamos con el precio de volumen.');
        }
        return;
      }

      yaCobrado = true;

      // El termo primero, con su archivo (FormData admite adjuntos);
      // enseguida la línea del grabado.
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('termo');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{
              id: Number(vid),
              quantity: caras * piezas,
              properties: { '_para': 'Grabado del termo de este pedido' }
            }] })
          });
        })
        .then(function () { window.location.href = destino; })
        .catch(function () {
          // Mejor un pedido sin la línea del grabado que un carrito vacío.
          yaCobrado = false;
          form.submit();
        });
    }

    var p1 = root.querySelector('.grabado-pasos [data-paso="1"]');
    if (p1) p1.addEventListener('click', function () {
      var f = root.querySelector('.grabado-file'); if (f) f.click();
    });
    var p3 = root.querySelector('.grabado-pasos [data-paso="3"]');
    if (p3) p3.addEventListener('click', function () {
      var b = root.querySelector('.grabado-add');
      if (hayArte() && b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else if (p1) p1.click();
    });

    var cerrar = root.querySelector('.grabado-add');
    if (cerrar) {
      cerrar.addEventListener('click', function () {
        cerrar.disabled = true;
        cerrar.textContent = 'Agregando…';
        // requestSubmit dispara el submit, que este mismo archivo intercepta.
        if (form.requestSubmit) form.requestSubmit(); else interceptar(new Event('submit'));
        setTimeout(function () {
          cerrar.disabled = false;
          cerrar.textContent = 'Añadir al carrito con grabado';
        }, 6000);
      });
    }

    form.addEventListener('submit', interceptar, true);
    var btn = form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
    if (btn) btn.addEventListener('click', interceptar, true);

    /* "Comprar ahora" es el botón de pago de Shopify: type="button", no pasa
       por el formulario y salta directo a checkout. Sin esto, quien pone su
       logo y usa ese botón se llevaría el grabado sin cobrar. Se intercepta
       igual, pero respetando su intención: se arma el carrito y se va a
       checkout, no al carrito. */
    var pago = form.querySelector('.shopify-payment-button__button');
    if (pago) {
      pago.addEventListener('click', function (e) {
        var caras = (faces.frente.art ? 1 : 0) + (faces.reverso.art ? 1 : 0);
        if (!caras || yaCobrado) return;         // sin logo: compra directa normal
        destino = '/checkout';
        interceptar(e);
      }, true);
    }
  }

  function ensureCartBox() {
    if (cartBox && cartBox.isConnected) return cartBox;
    var form = cartTarget();
    if (!form) return null;
    // Sin esto el navegador manda el nombre del archivo en vez del archivo.
    form.setAttribute('enctype', 'multipart/form-data');
    cartBox = document.createElement('div');
    cartBox.className = 'grabado-cart-fields';
    cartBox.hidden = true;
    form.appendChild(cartBox);
    return cartBox;
  }

  function field(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.value = value;
    return i;
  }

  function syncCart() {
    var box = ensureCartBox();
    if (!box) return;
    box.textContent = '';

    var conArte = [];
    ['frente', 'reverso'].forEach(function (k) {
      var f = faces[k];
      if (!f.art) return;
      conArte.push(k === 'frente' ? 'Frente' : 'Reverso');
      var et = k === 'frente' ? 'Frente' : 'Reverso';

      if (f.text.trim()) box.appendChild(field('Texto ' + et.toLowerCase(), f.text.trim()));
      box.appendChild(field('_arte_' + k, f.fname || 'archivo'));
      box.appendChild(field('_encuadre_' + k,
        'escala ' + f.size + '% · ' +
        (f.pos < 34 ? 'arriba' : f.pos > 66 ? 'abajo' : 'centro') + ' · ' +
        'umbral ' + f.thr + ' · fondo ' + f.bg +
        (f.artMM ? ' · ' + f.artMM.w.toFixed(0) + 'x' + f.artMM.h.toFixed(0) + 'mm' : '')));

      // El archivo original va al pedido tal cual lo entregó el cliente.
      if (f.file) {
        var fi = document.createElement('input');
        fi.type = 'file';
        fi.name = 'properties[Logo ' + et.toLowerCase() + ']';
        var dt = new DataTransfer();
        dt.items.add(f.file);
        fi.files = dt.files;
        box.appendChild(fi);
      }
    });

    if (conArte.length) box.appendChild(field('Grabado', conArte.join(' y ')));
  }

  /* ------------------------------------------------------ carga de archivo */
  function setSource(src, file, dims) {
    var f = F();
    f.src = src; f.file = file; f.fname = file ? file.name : '';
    var n = root.querySelector('.grabado-fname');
    var d = root.querySelector('.grabado-fdim');
    if (n) n.textContent = f.fname;
    if (d) d.textContent = dims;
    syncFileUI();
    reprocess();
  }

  function syncFileUI() {
    var f = F();
    var drop = root.querySelector('.grabado-drop');
    var load = root.querySelector('.grabado-loaded');
    if (drop) drop.hidden = !!f.src;
    if (load) load.hidden = !f.src;
    var n = root.querySelector('.grabado-fname');
    if (n && f.src) n.textContent = f.fname;
  }

  function working(on, msg) {
    if (!busy) return;
    busy.hidden = !on;
    if (msg) busy.textContent = msg;
  }

  function loadPDF(file) {
    if (!window.pdfjsLib) { say('No se pudo abrir el PDF. Exporta el logo como PNG.'); return; }
    working(true, 'Abriendo el PDF…');
    var r = new FileReader();
    r.onload = function () {
      window.pdfjsLib.getDocument({ data: new Uint8Array(r.result) }).promise
        .then(function (pdf) { return pdf.getPage(1); })
        .then(function (page) {
          var vp = page.getViewport({ scale: 2 });
          var c = document.createElement('canvas');
          c.width = Math.round(vp.width); c.height = Math.round(vp.height);
          var g = c.getContext('2d');
          // El PDF puede venir sin fondo: se pinta blanco para que el umbral funcione.
          g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
          return page.render({ canvasContext: g, viewport: vp }).promise
            .then(function () { return c; });
        })
        .then(function (c) {
          working(false);
          setSource(c, file, c.width + ' × ' + c.height + ' px · pág. 1');
        })
        .catch(function () {
          working(false);
          say('No se pudo abrir ese archivo. Si es .ai o .eps, guárdalo como PDF o PNG.');
        });
    };
    r.readAsArrayBuffer(file);
  }

  function loadFile(file) {
    if (!file) return;
    say(null);

    if (file.size > 18 * 1024 * 1024) {
      say('El archivo pesa más de 18 MB y Shopify no lo aceptará. Mándalo más ligero.');
      return;
    }
    if (file.type === 'application/pdf' || /\.(pdf|ai)$/i.test(file.name)) return loadPDF(file);
    if (/\.eps$/i.test(file.name)) { say('Los .eps no se abren en el navegador. Guárdalo como PDF o PNG.'); return; }
    if (!/^image\//.test(file.type)) { say('Formato no reconocido. Usa PDF, PNG, JPG o SVG.'); return; }

    var r = new FileReader();
    r.onload = function () {
      var img = new Image();
      img.onload = function () {
        setSource(img, file, img.naturalWidth + ' × ' + img.naturalHeight + ' px');
      };
      img.onerror = function () { say('No se pudo leer ese archivo. Prueba con PNG o JPG.'); };
      img.src = r.result;
    };
    r.readAsDataURL(file);
  }

  /* -------------------------------------------------------------- controles */
  function bindControls() {
    var fileIn = root.querySelector('.grabado-file');
    var drop   = root.querySelector('.grabado-drop');

    if (fileIn) fileIn.addEventListener('change', function (e) {
      loadFile(e.target.files[0]); e.target.value = '';
    });

    if (drop) {
      drop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileIn.click(); }
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); });
      });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) loadFile(e.dataTransfer.files[0]);
      });
    }

    var clear = root.querySelector('.grabado-clear');
    if (clear) clear.addEventListener('click', function () {
      var f = F();
      f.src = null; f.art = null; f.artMM = null; f.file = null; f.fname = '';
      syncFileUI(); say(null); refresh();
    });

    bindRange('.grabado-thr',  'thr',  reprocess, function (v) { return v; });
    bindRange('.grabado-size', 'size', refresh,   function (v) { return v + ' %'; });
    bindRange('.grabado-tsize','textSize', refresh, function (v) { return v + ' %'; });
    bindRange('.grabado-pos',  'pos',  refresh,   function (v) {
      return v < 34 ? 'arriba' : v > 66 ? 'abajo' : 'centro';
    });

    var txt = root.querySelector('.grabado-txt');
    if (txt) txt.addEventListener('input', function (e) { F().text = e.target.value; refresh(); });

    root.querySelectorAll('[data-font]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.querySelectorAll('[data-font]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        useFont(b.getAttribute('data-font'));
      });
    });

    root.querySelectorAll('[data-caps]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        F().mayus = b.getAttribute('data-caps') === '1';
        refresh();
      });
    });

    var zone = root.querySelector('.grabado-zone');
    if (zone) zone.addEventListener('change', refresh);

    root.querySelectorAll('[data-bg]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        F().bg = b.getAttribute('data-bg');
        reprocess();
      });
    });

    root.querySelectorAll('[data-face]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        active = b.getAttribute('data-face');
        say(null); syncControls(); refresh();
      });
    });
  }

  /* Canvas no espera a que la webfont llegue: si se dibuja antes, el texto
     sale con la fuente de respaldo. Se pide la carga y se vuelve a dibujar. */
  function useFont(id) {
    F().font = id;
    var ft = fontById(id);
    refresh();
    if (document.fonts && document.fonts.load) {
      document.fonts.load(ft.peso + ' 48px ' + ft.css.split(',')[0])
        .then(refresh)
        .catch(function () {});
    }
  }

  function bindRange(sel, key, after, fmt) {
    var el = root.querySelector(sel);
    if (!el) return;
    var out = root.querySelector(sel + '-out');
    el.addEventListener('input', function (e) {
      F()[key] = +e.target.value;
      if (out) out.textContent = fmt(F()[key]);
      after();
    });
  }

  function syncControls() {
    var f = F();
    [['.grabado-thr', f.thr, function (v) { return v; }],
     ['.grabado-size', f.size, function (v) { return v + ' %'; }],
     ['.grabado-tsize', f.textSize, function (v) { return v + ' %'; }],
     ['.grabado-pos', f.pos, function (v) { return v < 34 ? 'arriba' : v > 66 ? 'abajo' : 'centro'; }]
    ].forEach(function (r) {
      var el = root.querySelector(r[0]);
      if (el) el.value = r[1];
      var out = root.querySelector(r[0] + '-out');
      if (out) out.textContent = r[2](r[1]);
    });

    var txt = root.querySelector('.grabado-txt');
    if (txt) txt.value = f.text;
    root.querySelectorAll('[data-font]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-font') === f.font));
    });
    root.querySelectorAll('[data-caps]').forEach(function (b) {
      b.setAttribute('aria-pressed', String((b.getAttribute('data-caps') === '1') === f.mayus));
    });

    root.querySelectorAll('[data-bg]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-bg') === f.bg));
    });
    syncFileUI();
  }

  /* El personalizador vive al 45% de la página, debajo de todo el bloque de
     producto. Nadie baja hasta allá antes de decidir, así que se planta un
     acceso junto al botón de comprar — donde el ojo ya está — y ese acceso
     lleva a la sección. */
  var cta = null;

  function precioTexto(piezas) {
    var e = escalonPara(piezas || 1);
    return String((e && e.texto) || root.getAttribute('data-precio') || '').trim();
  }

  function precioHTML() {
    var p = precioTexto();
    return p ? '<span class="grabado-cta-precio">' + p + '</span>' : '';
  }

  function pintarPrecioPanel() {
    var p = precioTexto();
    if (!p) return;
    // Una sola vez y junto a "Tu logo": la plantilla puede ya traerlo impreso.
    if (root.querySelector('.grabado-precio-inline')) return;
    var k = null;
    root.querySelectorAll('.grabado-k').forEach(function (e) {
      if (!k && /^tu logo/i.test((e.textContent || '').trim())) k = e;
    });
    if (!k) return;
    var b = document.createElement('b');
    b.className = 'grabado-precio-inline';
    b.textContent = p;
    k.appendChild(b);
  }

  /* El grabado también aparece como producto suelto en "También te puede
     interesar". Ahora que entra solo al carrito, ahí sobra y se prestaría a
     que lo agreguen dos veces. Se oculta la tarjeta, no el producto: sigue
     publicado porque el carrito lo necesita. */
  function ocultarDeRecomendados() {
    var c = cobro();
    var ids = [];
    if (c.variante) ids.push(String(c.variante));
    (c.escalones || []).forEach(function (e) { if (e.variante) ids.push(String(e.variante)); });
    if (!ids.length) return;

    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (inp) {
      if (ids.indexOf(String(inp.value)) === -1) return;
      var card = inp.closest('.upsell-product, .product-card, .grid__item, li');
      if (card) card.hidden = true;
    });
  }

  /* Volumen: el cliente arma su render igual que todos y se lleva el diseño
     por WhatsApp. El mensaje viaja con lo que el taller necesita — piezas,
     caras, medida en mm y encuadre — así la cotización empieza con el trabajo
     ya hecho en vez de con "mándame tu logo". */
  function resumenDiseno(piezas) {
    var l = ['Hola, quiero cotizar grabado por volumen.', ''];
    l.push('Producto: ' + (document.title.split('—')[0] || '').trim());
    l.push('Piezas: ' + (piezas || cantidadDelForm(cartTarget() || document.body)));
    ['frente', 'reverso'].forEach(function (k) {
      var f = faces[k];
      if (!f.art) return;
      var et = k === 'frente' ? 'Frente' : 'Reverso';
      l.push('');
      l.push(et + ':');
      l.push('  Archivo: ' + (f.fname || 'sin nombre'));
      if (f.artMM) l.push('  Medida: ' + f.artMM.w.toFixed(0) + ' x ' + f.artMM.h.toFixed(0) + ' mm');
      if (f.text.trim()) l.push('  Texto: ' + f.text.trim() + ' (' + fontById(f.font).nom + ')');
      l.push('  Encuadre: ' + f.size + '% · ' +
             (f.pos < 34 ? 'arriba' : f.pos > 66 ? 'abajo' : 'centro'));
    });
    l.push('');
    l.push(location.href.split('?')[0]);
    return l.join(String.fromCharCode(10));
  }

  function ligaWhatsApp(piezas) {
    var tel = String(cobro().whatsapp || '').replace(/[^0-9]/g, '');
    if (!tel) return null;
    return 'https://wa.me/' + tel + '?text=' + encodeURIComponent(resumenDiseno(piezas));
  }

  function dinero(n) {
    return '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* Lo que se va a cobrar, dicho antes de agregar al carrito: cuántas caras,
     por cuántas piezas y el monto. Sin esto el cliente no sabe que el grabado
     entra como una línea aparte. */
  function pintarResumen() {
    var caja = root.querySelector('.grabado-resumen');
    if (!caja) return;
    var precio = Number(cobro().precio || 0);
    var caras = (faces.frente.art ? 1 : 0) + (faces.reverso.art ? 1 : 0);
    if (!caras || !precio) { caja.hidden = true; return; }

    var form = cartTarget();
    var piezas = form ? cantidadDelForm(form) : 1;
    caja.hidden = false;

    var det = caras + (caras === 1 ? ' cara' : ' caras');
    if (piezas > 1) det += ' × ' + piezas + ' piezas';
    caja.querySelector('.grabado-res-det').textContent = det;
    var monto = precio * caras * piezas;
    caja.querySelector('.grabado-res-monto').textContent = dinero(monto);
    var b = caja.querySelector('.grabado-add');
    if (b && !b.disabled) b.textContent = 'Añadir al carrito con grabado';
  }

  function pintarVolumen() {
    var caja = root.querySelector('.grabado-volumen');
    if (!caja) return;
    var hay = faces.frente.art || faces.reverso.art;
    var liga = ligaWhatsApp();
    caja.hidden = !(hay && liga);
    if (!caja.hidden) {
      var a = caja.querySelector('a');
      if (a) a.href = liga;
    }
  }

  function insertCTA() {
    var form = cartTarget();
    if (!form || !form.parentElement || cta) return;

    cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'grabado-cta';
    // Sin ícono en círculo, sin tarjeta, sin relleno: dos filetes y tres
    // escalas tipográficas. El contraste de tamaño hace el trabajo que en la
    // versión anterior hacía el color.
    cta.innerHTML =
      '<canvas class="grabado-cta-mini" width="132" height="132" aria-hidden="true"></canvas>' +
      '<span class="grabado-cta-txt">' +
        '<span class="grabado-cta-kicker"></span>' +
        '<span class="grabado-cta-head"></span>' +
      '</span>' +
      '<span class="grabado-cta-act"></span>';

    cta.addEventListener('click', function () {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var f = root.querySelector('.grabado-file');
      if (f && !F().src) setTimeout(function () { f.click(); }, 620);
    });

    form.parentElement.insertBefore(cta, form);
  }

  /* Miniatura del termo tal como está en el visor: con el ejemplo o con el
     logo del cliente. Se recorta alrededor del cuerpo para que se lea. */
  function pintarMini() {
    var m = cta && cta.querySelector('.grabado-cta-mini');
    if (!m || !cv) return;
    var sc = cv.width / STAGE;
    // Recorte a la zona grabada, no al termo entero: a 58 px el logo tiene
    // que leerse.
    var lado = Math.max(ZONE.w, ZONE.h) * 1.12;
    var cx = ZONE.x + ZONE.w / 2, cy = ZONE.y + ZONE.h / 2;
    var g = m.getContext('2d');
    g.fillStyle = '#fff'; g.fillRect(0, 0, m.width, m.height);
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    g.drawImage(cv, (cx - lado / 2) * sc, (cy - lado / 2) * sc, lado * sc, lado * sc, 0, 0, m.width, m.height);
  }

  /* Los tres pasos: se marca el que toca y los hechos. */
  function pintarPasos() {
    var hay = hayArte();
    root.querySelectorAll('.grabado-pasos [data-paso]').forEach(function (li) {
      var n = li.getAttribute('data-paso');
      li.classList.toggle('hecho', hay && n === '1');
      li.classList.toggle('activo', hay ? n !== '1' : n === '1');
    });
    var ej = root.querySelector('.grabado-ejemplo');
    if (ej) ej.hidden = hay || active !== 'frente';
  }

  function markCTA() {
    if (!cta) return;
    var n = (faces.frente.art ? 1 : 0) + (faces.reverso.art ? 1 : 0);
    var k = cta.querySelector('.grabado-cta-kicker');
    var h = cta.querySelector('.grabado-cta-head');
    var a = cta.querySelector('.grabado-cta-act');
    if (!k || !h || !a) return;
    var precio = precioTexto();
    if (n) {
      cta.classList.add('listo');
      k.textContent = (n === 2 ? 'Dos caras' : 'Una cara') + ' con tu logo' + (precio ? ' · ' + precio : '');
      h.textContent = 'Tu logo va incluido';
      a.innerHTML = 'Ajustar<i aria-hidden="true">&rarr;</i>';
    } else {
      cta.classList.remove('listo');
      k.textContent = 'Grabado láser' + (precio ? ' · ' + precio : '');
      h.textContent = '¿Quieres ponerle tu logo?';
      a.innerHTML = 'Pícale aquí<i aria-hidden="true">&rarr;</i>';
    }
    pintarMini();
  }

  /* El selector muestra cada nombre en su propia tipografía: si no están
     cargadas, todas salen iguales. Se piden todas de una vez al arrancar. */
  function precargarFuentes() {
    if (!document.fonts || !document.fonts.load) return;
    FONTS.forEach(function (ft) {
      document.fonts.load(ft.peso + ' 24px ' + ft.css.split(',')[0]).catch(function () {});
    });
  }

  function boot() {
    if (booted) return;
    booted = true;
    precargarFuentes();
    root.hidden = false;
    pintarPrecioPanel();
    insertCTA();
    engancharCobro();
    // Los recomendados llegan por AJAX: se reintenta un par de veces.
    ocultarDeRecomendados();
    setTimeout(ocultarDeRecomendados, 1500);
    setTimeout(ocultarDeRecomendados, 4000);
    bindControls();
    syncControls();
    refresh();
    // Viene del letrero de la tarjeta en la colección: se lleva directo al
    // visor, sin obligarlo a buscar la sección bajando la página.
    if (desdeTarjeta) {
      setTimeout(function () {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 700);
    }
  }
})();
